function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import Slide from './slide';

/**
 * @param {Function} callback
 * @param {Number} wait
 * @return {Function}
 */
function $debounce(callback, wait) {
  var timeout;
  return function (e) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      callback(e);
    }, wait);
  };
}
function $updateControlsVisibility() {
  var index = this.currentSlide.index;
  var minIndex = 0,
    maxIndex = this.slideList.length - this.totalVisibleItems;
  var _this$controlsNav$chi = _slicedToArray(this.controlsNav.children, 2),
    buttonPrev = _this$controlsNav$chi[0],
    buttonNext = _this$controlsNav$chi[1];
  buttonPrev.disabled = !this.options.fakeInfinite && (index === minIndex || this.slideList.length <= this.totalVisibleItems);
  buttonNext.disabled = !this.options.fakeInfinite && (index === maxIndex || this.slideList.length <= this.totalVisibleItems);
}
function $slidePrev(e) {
  e.preventDefault();
  e.stopPropagation();
  if (this.currentSlide.prev) {
    this.translateTo(this.currentSlide.prev.index);
  } else if (this.options.fakeInfinite) {
    this.translateTo(this.slideList.length - 1);
  } else {
    $updateControlsVisibility.call(this);
  }
}
function $slideNext(e) {
  e.preventDefault();
  e.stopPropagation();
  if (this.currentSlide.next) {
    this.translateTo(this.currentSlide.next.index);
  } else if (this.options.fakeInfinite) {
    this.translateTo(0);
  } else {
    $updateControlsVisibility.call(this);
  }
}
function $bindEvents() {
  return _$bindEvents.apply(this, arguments);
}
function _$bindEvents() {
  _$bindEvents = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var _this2 = this;
    var _this$controlsNav$chi2, buttonPrev, buttonNext, scrollEnd, resizeEnd;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          // Controls
          _this$controlsNav$chi2 = _slicedToArray(this.controlsNav.children, 2), buttonPrev = _this$controlsNav$chi2[0], buttonNext = _this$controlsNav$chi2[1];
          buttonPrev.addEventListener('click', $slidePrev.bind(this));
          buttonNext.addEventListener('click', $slideNext.bind(this));
          if (this.options.manualScroll) {
            // Manual slide (touch)
            if (this.options.manualScroll === 'touch' || this.options.manualScroll === 'both') {
              this.bindManualScrollEvent('touchstart', 'touchmove', 'touchend', function (e) {
                return e.touches[0];
              });
            }

            // Manual slide (mouse)
            if (this.options.manualScroll === 'mouse' || this.options.manualScroll === 'both') {
              this.bindManualScrollEvent('mousedown', 'mousemove', 'mouseup', function (e) {
                return e;
              });
            }
          }

          // Dots navigation
          if (this.dotNavigation) {
            this.bindDotNavigationEvent();
          }

          // Update component once after translation scroll ended
          scrollEnd = $debounce(function () {
            var oldIndex = _this2.$index;
            _this2.updateComponent();
            _this2.translateTo(_this2.$index, true, oldIndex !== _this2.$index);
          }, 100);
          this.container.addEventListener('scroll', scrollEnd, {
            passive: true
          });

          // Resize end detection (for responsive)
          resizeEnd = $debounce(function () {
            _this2.translateTo(_this2.$index, false);
            if (_this2.dotNavigation) _this2.initDotNavigation();
            $updateControlsVisibility.call(_this2);
          }, 100);
          window.addEventListener('resize', resizeEnd, {
            passive: true
          });
        case 1:
          return _context.a(2);
      }
    }, _callee, this);
  }));
  return _$bindEvents.apply(this, arguments);
}
var Slider = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {Object} options
   */
  function Slider(options) {
    var _this = this;
    _classCallCheck(this, Slider);
    this.options = {
      id: null,
      // {String}
      element: null,
      // {HTMLElement}
      manualScroll: false,
      // {Boolean|String} false|mouse|touch|both
      fakeInfinite: false // {Boolean}
    };
    Object.assign(this.options, options);
    this.root = document.querySelector(".js-slider-".concat(this.options.id)) || this.options.element || null;
    if (!this.root) {
      throw new Error('[Slider] Root is null!');
    }
    this.container = this.root.querySelector('.mc-slider__container');
    this.slidesContainer = this.root.querySelector('.mc-slider__slides');
    this.controlsNav = this.root.querySelector('.mc-slider__controls');
    this.dotNavigation = this.root.querySelector('.mc-slider__navigation') || null;
    this.slideList = _toConsumableArray(this.slidesContainer.children).map(function (slide) {
      return new Slide(slide, _this);
    });
    this.slideList.forEach(function (slide, index, arr) {
      slide.index = index;
      slide.prev = arr[index - 1] || null;
      slide.next = arr[index + 1] || null;
    });
    this.$index = parseInt(this.root.dataset.current) || 0;
    if (this.$index > 0) {
      this.translateTo(this.$index, false);
    }
    var promises = [];
    if (this.options.manualScroll) {
      promises.push(import(/* webpackChunkName: "manualScroll" */'./components/ManualScroll.js').then(function (module) {
        new module["default"](Slider);
      }));
    }
    if (this.dotNavigation) {
      promises.push(import(/* webpackChunkName: "dotNavigation" */'./components/DotNavigation.js').then(function (module) {
        new module["default"](Slider);
      }));
    }
    Promise.all(promises).then(function () {
      if (_this.dotNavigation) _this.initDotNavigation();
      _this.updateComponent();
      $bindEvents.call(_this);
    });
  }

  /**
   * @return {HTMLElement[]}
   */
  return _createClass(Slider, [{
    key: "fullyVisibleSlideList",
    get: function get() {
      return this.slideList.filter(function (slide) {
        return slide.isFullyVisible();
      });
    }

    /**
     * @return {Number}
     */
  }, {
    key: "totalVisibleItems",
    get: function get() {
      var containerWidth = parseFloat(window.getComputedStyle(this.container).width);
      var _this$slidesContainer = _slicedToArray(this.slidesContainer.children, 1),
        first = _this$slidesContainer[0];
      var firstSlide = new Slide(first, this);
      var coveredWidth = containerWidth % firstSlide.width - (Math.floor(containerWidth / firstSlide.width) - 1) * firstSlide.gap;
      return Math.floor(containerWidth / firstSlide.width) + (coveredWidth < 0 ? -1 : 0);
    }

    /**
     * @return {Slide}
     */
  }, {
    key: "currentSlide",
    get: function get() {
      var _this$fullyVisibleSli = _slicedToArray(this.fullyVisibleSlideList, 1),
        current = _this$fullyVisibleSli[0];
      if (!current) {
        var visibleWidthList = this.slideList.map(function (slide) {
          return slide.visibleWidth;
        });
        return this.slideList[visibleWidthList.indexOf(Math.max.apply(Math, _toConsumableArray(visibleWidthList)))];
      }
      return current;
    }

    /**
     * @param {Number} index
     * @param {Boolean} transition
     * @param {Boolean} emitEvent
     */
  }, {
    key: "translateTo",
    value: function translateTo(index) {
      var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var emitEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (transition && emitEvent) {
        var direction = this.currentSlide.index > index ? 'right' : 'left';
        this.root.dispatchEvent(new CustomEvent('slide', {
          detail: {
            direction: direction,
            targetSlide: this.slideList[index]
          }
        }));
      }
      this.slideList[index].translateTo(transition);
      this.$index = index;
    }
  }, {
    key: "updateComponent",
    value: function updateComponent() {
      this.$index = this.currentSlide.index;
      $updateControlsVisibility.call(this);
      if (this.dotNavigation) this.updateDotNavigation();
    }
  }]);
}();
export { Slider as default };